import { create } from 'zustand'

interface ModalProps {
  [key: string]: any
}

interface ModalDialog<P = ModalProps> {
  isOn: boolean
  props: P
  closeModal: () => void
  openModal: () => void
  switchModal: () => void
  openPropsModal: (props: P) => void
  clearProps: () => void
  callBack?: () => Promise<void>
  setCallback: (callback: () => Promise<void>) => void
  // Make executeCallback return a Promise
  executeCallback: () => Promise<void>
  // Add a method to close and execute
  closeAndExecute: () => Promise<void>
}

export const createModalStore = <P = ModalProps>(stateModal: boolean = false) =>
  create<ModalDialog<P>>((set, get) => ({
    isOn: stateModal,
    props: {} as P,
    setOn: () => set((state) => ({ isOn: !state.isOn })),
    switchModal: () => set((state) => ({ isOn: !state.isOn })),
    closeModal: () => set({ isOn: false }),
    openModal: () => set({ isOn: true }),
    openPropsModal: (props: P) => set({ props, isOn: true }),
    clearProps: () => set({ props: {} as P, callBack: undefined }),
    callBack: undefined,
    setCallback: (callback: () => Promise<void>) => set({ callBack: callback }),
    executeCallback: async () => {
      const callback = get().callBack
      if (callback) {
        await callback()
      }
    },
    // Add a convenience method to close and execute
    closeAndExecute: async () => {
      const store = get()
      store.closeModal()
      await store.executeCallback()
    },
  }))
